import React from 'react';
import MyEventCartContainer from '../../Containers/UserContainer/MyEventsCart';

const MyEventCartScreen = () => {
  return <MyEventCartContainer />;
};

export default MyEventCartScreen;
